import React, {useEffect, useRef, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Grid from '@mui/material/Grid';
import './activities.css';


function ActivityDialogEditDetails({ isOpen, onClose, eventActivity, setEventActivity }) {



    const [activityTitle, setActivityTitle] = useState(eventActivity.title || "");
    const [locationName, setLocationName] = useState(eventActivity['location'].name || "");
    const [bookedThrough, setBookedThrough] = useState(eventActivity.booked_through);
    const [confirmationNumber, setConfirmationNumber] = useState(eventActivity.confirmation_number);
    const [reservationName, setReservationName] = useState(eventActivity.reservation_name);
    const [reservationNumber, setReservationNumber] = useState(eventActivity.reservation_number);
    const [website, setWebsite] = useState(eventActivity.website);
    const [bring, setBring] = useState(eventActivity.bring);
    const [details, setDetails] = useState(eventActivity.details);
    const [notes, setNotes] = useState(eventActivity.notes);

    // Store the initial values using useRef
    const initialValues = useRef({
        activityTitle: eventActivity.title || "",
        locationName: eventActivity['location'].name || "",
        bookedThrough: eventActivity.booked_through || "",
        confirmationNumber: eventActivity.confirmation_number || "",
        reservationName: eventActivity.reservation_name || "",
        reservationNumber: eventActivity.reservation_number || "",
        website: eventActivity.website || "",
        bring: eventActivity.bring || "",
        details: eventActivity.details || "",
        notes: eventActivity.notes || ""
    });

    // Check if any value has changed
    useEffect(() => {
        const hasChanges =
            activityTitle !== initialValues.current.activityTitle ||
            locationName !== initialValues.current.locationName ||
            bookedThrough !== initialValues.current.bookedThrough ||
            confirmationNumber !== initialValues.current.confirmationNumber ||
            reservationName !== initialValues.current.reservationName ||
            reservationNumber !== initialValues.current.reservationNumber ||
            website !== initialValues.current.website ||
            bring !== initialValues.current.bring ||
            details !== initialValues.current.details ||
            notes !== initialValues.current.notes;
    }, [activityTitle, locationName, bookedThrough, confirmationNumber, reservationName,
        reservationNumber, website, bring, details, notes]);

    function handleTitleChange(event) {
        setActivityTitle(event.target.value);
    }
    function handleLocationNameChange(event) {
        setLocationName(event.target.value);
    }
    function handleBookedThroughChange(event){
        setBookedThrough(event.target.value);
    }
    function handleConfirmationNumberChange(event){
        setConfirmationNumber(event.target.value);
    }
    function handleReservationNameChange(event){
        setReservationName(event.target.value);
    }
    function handleReservationNumberChange(event){
        setReservationNumber(event.target.value);
    }
    function handleWebsiteChange(event){
        setWebsite(event.target.value);
    }
    function handleBringChange(event){
        setBring(event.target.value);
    }
    function handleDetailsChange(event){
        setDetails(event.target.value);
    }
    function handleNotesChange(event){
        setNotes(event.target.value);
    }
    function saveEventActivitySettings() {

        const updatedActivity = {
            ...eventActivity,
            title: activityTitle,
            location: {
                ...eventActivity.location, // Preserve existing location details
                name: locationName, // Update the activity location name
            },
            booked_through: bookedThrough,
            confirmation_number: confirmationNumber,
            reservation_name: reservationName,
            reservation_number: reservationNumber,
            website: website,
            bring: bring,
            details: details,
            notes: notes
        };

        setEventActivity(updatedActivity);


        // Reset the initial values to the new saved state
        initialValues.current = {
            activityTitle,
            locationName,
            bookedThrough,
            confirmationNumber,
            reservationName,
            reservationNumber,
            website,
            bring,
            details,
            notes
        };

        onClose();
    }





    return (

        <Dialog open={isOpen} onClose={onClose} PaperProps={{
            sx: {
                minWidth: 350, // or '350px'
                maxWidth: 500, // optional
                width: '100%', // allows it to scale on smaller screens
            },
        }}>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                Activity Details
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent>
                <Grid container spacing={2} direction="column">
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_title"
                            label="Title"
                            value={activityTitle}
                            onChange={handleTitleChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_location_name"
                            label="Location Name"
                            value={locationName}
                            onChange={handleLocationNameChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_booked_through"
                            label="Booked Through"
                            value={bookedThrough}
                            onChange={handleBookedThroughChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_confirmation_number"
                            label="Confirmation Number"
                            value={confirmationNumber}
                            onChange={handleConfirmationNumberChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_reservation_name"
                            label="Reservation Name"
                            value={reservationName}
                            onChange={handleReservationNameChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_reservation_number"
                            label="Reservation Number"
                            value={reservationNumber}
                            onChange={handleReservationNumberChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_website"
                            label="Website"
                            value={website}
                            onChange={handleWebsiteChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_bring"
                            label="Bring (separate with commas)"
                            multiline
                            rows={4}
                            value={bring}
                            onChange={handleBringChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_details"
                            label="Details"
                            multiline
                            rows={4}
                            value={details}
                            onChange={handleDetailsChange}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            fullWidth
                            id="edit_activity_notes"
                            label="Notes"
                            multiline
                            rows={4}
                            value={notes}
                            onChange={handleNotesChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondary">Close</Button>
                <Button
                    onClick={saveEventActivitySettings}
                    variant="contained"
                    color="primary"
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ActivityDialogEditDetails;